// eslint-disable-next-line no-undef
const msg: Record<string, string> = {
  "workout-sequence.title-duplicated":
    "A sequence with this title already exists",
  "internal-server-error": "Server Error. Please try again later.",
  "active-programs.invalid-sequence":
    "Invalid Sequence. Please try again later.",
  "workout-sequence-day.exists-workout-sequence-day":
    "A sequence with this day already exists ",
  "active-programs.workout-sequence-unallowed": "Workout sequence unallowed",
  "workout-sequence-day.workout-not-found": "Video not available",
  "workout-sequence-day.workout-already-added": "Workout already added",
  "collections.name-duplicated": "A collection with this name already exists",
  "collections.value-duplicated": "A collection with this value already exists",
  "vimeo-url-not-correct":
    "The requested video url isn't valid for vimeo video.",
};

export const getMessage = (key: string): string => {
  return msg[key] ? msg[key] : "Something went wrong.";
};
